import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '@/components/sections/Hero';
import About from '@/components/sections/About';
import ServicesGrid from '@/components/sections/ServicesGrid';
import WhyChooseUs from '@/components/sections/WhyChooseUs';
import FAQ from '@/components/sections/FAQ';
import Contact from '@/components/sections/Contact';

const HomePage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 80);
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <About />
      <ServicesGrid />
      <WhyChooseUs />
      <FAQ />
      <Contact />
    </main>
  );
};

export default HomePage;
